
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const getExchangeLogo = (exchange: string) => {
  switch (exchange) {
    case "OKX":
      return "/lovable-uploads/9374987f-70d0-4ef3-a74d-deada4d71a29.png";
    case "Bybit":
      return "/lovable-uploads/f8e24343-7970-4066-8449-f3d42e90e07e.png";
    case "Bitget":
      return "/lovable-uploads/c82b7495-c4d9-462e-90d9-bb62f24a1e7d.png";
    case "Phemex":
      return "/lovable-uploads/65150818-855b-40d2-b7f4-d5469fcee9b2.png";
    default:
      return "";
  }
};

export const getExchangeLink = (exchange: string) => {
  switch (exchange.toLowerCase()) {
    case "okx":
      return "https://www.okx.com/join/metrade";
    case "bybit":
      return "https://www.bybit.com/invite?ref=METRADEAPP";
    case "bitget":
      return "https://partner.bitget.com/bg/metrade";
    case "phemex":
      return "https://phemex.com/register-vt1?referralCode=METRADE";
    default:
      return "https://www.okx.com/join/metrade";
  }
};

export const getExchangeAffiliateLink = (exchange: string) => {
  switch (exchange.toLowerCase()) {
    case "okx":
      return "https://www.okx.com/de/join/metrade";
    case "bybit":
      return "https://partner.bybit.com/b/metrade";
    case "bitget":
      return "https://bonus.bitget.com/YLE6ZV";
    case "phemex":
      return "https://phemex.com/promo/activity/competition/209?group=&referralCode=IVDDN8";
    default:
      return "https://www.okx.com/de/join/metrade";
  }
};

export const getFollowLink = async (strategyId: string): Promise<string> => {
  try {
    // Get the current user
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      console.error("Cannot get follow link: User not authenticated");
      toast("Authentication required", {
        description: "Please sign in to follow strategies"
      });
      throw new Error("Authentication required");
    }
    
    // Call the Supabase edge function to get an available follow link
    const { data, error } = await supabase.functions.invoke("get-follow-link", {
      body: { 
        strategyId,
        userId: user.id 
      },
    });
    
    if (error) {
      console.error("Error from get-follow-link function:", error);
      
      // Check for subscription required error
      if (error.message && error.message.includes("Subscription required")) {
        toast("Premium subscription required", {
          description: "Please subscribe to access premium strategies"
        });
        throw new Error("Subscription required");
      }
      
      throw error;
    }
    
    if (data?.url) {
      return data.url;
    }
    
    throw new Error("No follow link available");
  } catch (error: any) {
    console.error("Error getting follow link:", error);
    
    // Don't show generic error if it's a known error type that we've already handled
    if (!error.message.includes("Authentication required") && 
        !error.message.includes("Subscription required")) {
      toast("Error getting follow link", {
        description: error.message || "An unexpected error occurred"
      });
    }
    
    // Fall back to the static exchange link if there's an error
    const { data } = await supabase
      .from('strategy')
      .select('exchange')
      .eq('id', strategyId)
      .single();
      
    return getExchangeLink(data?.exchange || 'okx');
  }
};
